import { useMemo } from 'react';
import { calculateLossFromStopLoss } from '../../../common/utils/calculations.util';

export const useCloseAtLoss = ({
  store,
  absoluteLimitOfInvestment,
  symbolProperties,
  volume,
}) => {
  const onToggle = () => {
    store.toggleCloseAtLoss();
  };

  const min = useMemo(() => {
    if (store.stopLossLevel) {
      return calculateLossFromStopLoss({
        volume: volume.min,
        stopLossLevel: store.stopLossLevel,
        openPrice: store.openAtPriceOf,
        kRate: symbolProperties.kRate,
        contractSize: symbolProperties.contractSize,
        commission: symbolProperties.commission,
      });
    }
    return absoluteLimitOfInvestment.min;
  }, [
    absoluteLimitOfInvestment.min,
    store.stopLossLevel,
    store.openAtPriceOf,
    symbolProperties.kRate,
    symbolProperties.contractSize,
    symbolProperties.commission,
    volume.min,
  ]);

  const max = useMemo(() => {
    if (store.stopLossLevel) {
      return calculateLossFromStopLoss({
        volume: volume.max,
        stopLossLevel: store.stopLossLevel,
        openPrice: store.openAtPriceOf,
        kRate: symbolProperties.kRate,
        contractSize: symbolProperties.contractSize,
        commission: symbolProperties.commission,
      });
    }
    return absoluteLimitOfInvestment.max;
  }, [
    absoluteLimitOfInvestment.max,
    store.stopLossLevel,
    store.openAtPriceOf,
    symbolProperties.kRate,
    symbolProperties.contractSize,
    symbolProperties.commission,
    volume.max,
  ]);

  const value = useMemo(() => {
    if (store.stopLossLevel) {
      return calculateLossFromStopLoss({
        volume: volume.value,
        stopLossLevel: store.stopLossLevel,
        openPrice: store.openAtPriceOf,
        kRate: symbolProperties.kRate,
        contractSize: symbolProperties.contractSize,
        commission: symbolProperties.commission,
      });
    }
    return absoluteLimitOfInvestment.value;
  }, [
    store.stopLossLevel,
    store.openAtPriceOf,
    symbolProperties.kRate,
    symbolProperties.contractSize,
    symbolProperties.commission,
    absoluteLimitOfInvestment.value,
    volume.value,
  ]);

  return {
    value,
    min,
    max,
    onToggle,
    enabled: store.closeAtLoss,
  };
};
